import { render, staticRenderFns } from "./CarbonTransfer1.vue?vue&type=template&id=3d05f4e1&scoped=true&"
import script from "./CarbonTransfer1.vue?vue&type=script&lang=js&"
export * from "./CarbonTransfer1.vue?vue&type=script&lang=js&"
import style0 from "./CarbonTransfer1.vue?vue&type=style&index=0&id=3d05f4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05f4e1",
  null
  
)

export default component.exports